import { useContext } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { useForm } from "react-hook-form";
import { getActiveNewSimRoute } from "@api-routes/eirCustomersFacade";
import { getStateToPayload } from "../mappers/postActivateSimMapper";
import { useFetch } from "@common/hook/useFetch";

export const useActivateSim = (setIsModalOpen: (isModalOpen: boolean) => void) => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [validationCodeState, { post }] = useFetch();

    const formMethods = useForm<{ activationCode: string }>({ defaultValues: { activationCode: "" } });

    const handleSubmit = formMethods.handleSubmit((formData) => {
        if (selectedService) {
            post<boolean>(getActiveNewSimRoute(), {
                body: getStateToPayload(formData.activationCode, selectedService.id),
            }).then((result) => {
                if (result) {
                    setIsModalOpen(true);
                }
            });
        }
    });

    return { formMethods, validationCodeState, handleSubmit };
};
